const state = {
    streams: [],
    stream: null
}

const mutations = {
    SET_STREAMS (state, value) {
        value.unshift({id: 0, title: 'Base'})
        state.streams = value
    },
    SET_STREAM (state, value) {
        state.stream = value
    }
}

const actions = {
    setStreams ({commit, dispatch}, value) {
        commit('SET_STREAMS', value)
        dispatch('setStream', value[0]) // base
    },
    setStream ({commit}, value) {
        commit('SET_STREAM', value)
    },
    setStreamById ({commit, state}, value) {
        let filtered = state.streams.filter(stream => {
            return stream.id === value
        })
        commit('SET_STREAM', filtered.length > 0 ? filtered[0] : null)
    }
}

const getters = {
    stream: (state) => {
        return state.stream
    },
    challengeStreams: (state) => {
        let streams = state.streams
        streams.shift()
        return streams
    }
}

export default {
    state,
    mutations,
    actions,
    getters,
    namespaced: true
}
